import { FormBase } from 'core/components';

export default class RegisterForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [{
                name: 'email',
                label: 'REGISTER.FIELDS.EMAIL_LABEL',
                placeholder: 'REGISTER.FIELDS.EMAIL_PLACEHOLDER',
                rules: 'required|email|string'
            }, {
                name: 'firstName',
                label: 'REGISTER.FIELDS.FIRST_NAME_LABEL',
                placeholder: 'REGISTER.FIELDS.FIRST_NAME_PLACEHOLDER',
                rules: 'required|string'
            }, {
                name: 'lastName',
                label: 'REGISTER.FIELDS.LAST_NAME_LABEL',
                placeholder: 'REGISTER.FIELDS.LAST_NAME_PLACEHOLDER',
                rules: 'required|string'
            },{
                name: 'password',
                label: 'REGISTER.FIELDS.PASSWORD_LABEL',
                type: 'password',
                placeholder: 'REGISTER.FIELDS.PASSWORD_PLACEHOLDER',
                rules: ['required', 'string', 'min:8', 'regex:/([^a-zA-Z\\d])+([a-zA-Z\\d])+|([a-zA-Z\\d])+([^a-zA-Z\\d])+/']
            }, {
                name: 'confirmPassword',
                label: 'REGISTER.FIELDS.CONFIRM_PASSWORD_LABEL',
                placeholder: 'REGISTER.FIELDS.CONFIRM_PASSWORD_PLACEHOLDER',
                rules: 'required|string|same:password',
                type: 'password'
            },
            {
                name: 'botProtection',
                label: 'REGISTER.FIELDS.BOT_PROTECTION',
                rules: 'required|string'
            }],
        };
    }
}